import React from "react";
import HeaderContainer from "./Header.container";
import MenuContainer from "./Menu.container";
import { Outlet, useLocation } from "react-router-dom";
const LayoutComponent = (props: any) => {
    const { needStandaloneMain, needNoMenu } = props;
    return (
        <>
            {needStandaloneMain ? null : <HeaderContainer />}
            <Outlet />
            {needStandaloneMain || needNoMenu ? null : <MenuContainer />}
        </>
    );
};

export default LayoutComponent;